import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useAuth } from 'hooks/useAuth';
import useAPI from 'hooks/useApi';
// import commentsAPI from 'api/comments';
// import postsAPI from 'api/posts';
import loginAPI from 'api/login';

const LoginForm = ({ hasLabel, layout }) => {
  const { login } = useAuth();
  // const getPostsApi = useAPI(postsAPI.getPosts);
  // const getCommentsApi = useAPI(commentsAPI.getComments);
  const getLoginAPI = useAPI(loginAPI.getUser);
  const navigate = useNavigate();
  // State
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    remember: false
  });

  useEffect(() => {
    if (getLoginAPI.data) {
      login(getLoginAPI.data);
      navigate('/', { replace: true });
      toast.success(`Logged in as ${formData.username}`, {
        theme: 'colored'
      });
    }
  }, [getLoginAPI.data]);

  useEffect(() => {
    if (getLoginAPI.error) {
      toast.error(`You have entered an invalid username or password`, {
        theme: 'colored'
      });
    }
  }, [getLoginAPI.error]);

  // Handler
  const handleSubmit = e => {
    e.preventDefault();
    getLoginAPI.request({
      grant_type: 'password',
      scope: 'openid',
      username: formData.username,
      password: formData.password,
      client_id: process.env.REACT_APP_KEYCLOAK_CLIENT
    });
  };

  const handleFieldChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group className="mb-3">
        {hasLabel && <Form.Label>Username</Form.Label>}
        <Form.Control
          placeholder={!hasLabel ? 'Username' : ''}
          value={formData.email}
          name="username"
          onChange={handleFieldChange}
          type="text"
        />
      </Form.Group>

      <Form.Group className="mb-3">
        {hasLabel && <Form.Label>Password</Form.Label>}
        <Form.Control
          placeholder={!hasLabel ? 'Password' : ''}
          value={formData.password}
          name="password"
          onChange={handleFieldChange}
          type="password"
        />
      </Form.Group>

      <Row className="justify-content-between align-items-center">
        <Col xs="auto">
          <Form.Check type="checkbox" id="rememberMe" className="mb-0">
            <Form.Check.Input
              type="checkbox"
              name="remember"
              checked={formData.remember}
              onChange={e =>
                setFormData({
                  ...formData,
                  remember: e.target.checked
                })
              }
            />
            <Form.Check.Label className="mb-0 text-700">
              Remember me
            </Form.Check.Label>
          </Form.Check>
        </Col>

        <Col xs="auto">
          <Link
            className="fs--1 mb-0"
            to={`/authentication/${layout}/forgot-password`}
          >
            Forgot Password?
          </Link>
        </Col>
      </Row>

      <Form.Group>
        <Button
          type="submit"
          color="primary"
          className="mt-3 w-100"
          disabled={!formData.username || !formData.password}
        >
          Log in
        </Button>
      </Form.Group>
    </Form>
  );
};

LoginForm.propTypes = {
  layout: PropTypes.string,
  hasLabel: PropTypes.bool
};

LoginForm.defaultProps = {
  layout: 'simple',
  hasLabel: false
};

export default LoginForm;
